type Props = {
  count: number;
  busy: boolean;
  selectAllBusy: boolean;
  onSelectAll: () => void;
  onCancel: () => void;
  onDownload: () => void;
};

export function SelectionBar({
  count,
  busy,
  selectAllBusy,
  onSelectAll,
  onCancel,
  onDownload,
}: Props) {
  return (
    <div className="fixed inset-x-0 bottom-16 z-30 mx-auto flex max-w-lg items-center justify-between gap-2 rounded-lg bg-ink/95 px-3 py-2 text-white shadow-lg md:bottom-4">
      <span className="text-sm">{count} valittu</span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onSelectAll}
          disabled={busy || selectAllBusy}
          className="rounded border border-white/30 px-3 py-1.5 text-sm disabled:opacity-50"
        >
          {selectAllBusy ? "Ladataan…" : "Valitse kaikki"}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="rounded border border-white/30 px-3 py-1.5 text-sm"
          disabled={busy}
        >
          Peruuta
        </button>
        <button
          type="button"
          onClick={onDownload}
          disabled={count === 0 || busy}
          className="rounded bg-white px-3 py-1.5 text-sm font-medium text-ink disabled:opacity-50"
        >
          {busy ? "Valmistellaan…" : "Lataa ZIP"}
        </button>
      </div>
    </div>
  );
}
